import React from "react";
var __jsx = React.createElement;
import { useMemo } from 'react';
import { connectHits } from 'react-instantsearch-dom';
import { hitsToSearchItems } from 'libs/content/transformers/hitsToSearchItems';
import SearchItemList from './SearchItemList';

var ContentListHits = function ContentListHits(_ref) {
  var hits = _ref.hits,
      HoverIcon = _ref.HoverIcon,
      onClick = _ref.onClick;
  var contentListItems = useMemo(function () {
    return hitsToSearchItems(hits);
  }, [hits]);
  return __jsx(SearchItemList, {
    searchItems: contentListItems,
    HoverIcon: HoverIcon,
    onClick: onClick
  });
};

var AlgoliaSearchItemList = connectHits(ContentListHits);
export default AlgoliaSearchItemList;